import React from 'react';
import { Box, IconButton, Popover, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { menuLinks } from '../../constants/NavBar/menuLinks';

export default function SimpleMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <>
        <IconButton
            aria-describedby={id}
            aria-label="menu"
            onClick={handleClick}
            size="large"
            edge="start"
            sx={{ color: 'white', display: { xs: 'none', sm: 'flex' } }} 
        >
            <MenuIcon />
        </IconButton>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
            }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }}
            disableRestoreFocus
            PaperProps={{
                sx: {
                    borderRadius: 3, 
                },
            }}
        >
            <Box sx={{ p: 2, width: 240 }}>
            <List>
                {menuLinks.map(({ label, url }) => (
                    <ListItem button component="a" href={url} target="_blank" rel="noopener noreferrer" onClick={handleClose} key={label}>
                        <ListItemText primary={label} sx={{
                            color: 'var(--c-brand-link)',
                            textAlign: 'center',
                            whiteSpace: 'nowrap', 
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }} />
                    </ListItem>
                ))}
            </List>
            </Box>
        </Popover>
        </>
    );
}
